import React from "react";
import { getAidsList } from "./dashboardUtils";

export default function PaxDetailsPopup({
  selectedPax,
  editedPhones,
  setEditedPhones,
  originalPhones,
  savePaxChanges,
  isSaving,
  paxBalance,
  allowTopUp,
  canShowStripe,
  canShowBalance,
  onAddFunds,
  onClose,
  clientData,
}) {
  const hasChanges =
    editedPhones.telephone.trim() !== originalPhones.telephone.trim() ||
    editedPhones.altTelephone.trim() !== originalPhones.altTelephone.trim() ||
    editedPhones.mobile.trim() !== originalPhones.mobile.trim();

  const aidsList = getAidsList(selectedPax.Aids);

  const canChangePhoneNumbers =
    Number(clientData?.PaxProfileCanChangePhoneNumbers) === 1;

  return (
    <div className="popup-wrapper" onClick={onClose}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <div className="popup-header">
          <span>
            Profile - {selectedPax.Title} {selectedPax.Forename}{" "}
            {selectedPax.Surname}
          </span>
          <button className="popup-close" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="popup-body">
          <div className="label-value-row">
            <label>Home Address:</label>
            <span className="value">
              {selectedPax.Address} {selectedPax.Postcode}
            </span>
          </div>

          <div className="label-value-row">
            <label>Email Address:</label>
            <span className="value">{selectedPax.Email}</span>
          </div>

          <div className="phone-field">
            <label>Telephone:</label>
            <input
              type="text"
              value={editedPhones.telephone}
              disabled={!canChangePhoneNumbers}
              onChange={(e) =>
                setEditedPhones({
                  ...editedPhones,
                  telephone: e.target.value,
                })
              }
            />
          </div>

          <div className="phone-field">
            <label>Alternate Telephone:</label>
            <input
              type="text"
              value={editedPhones.altTelephone}
              disabled={!canChangePhoneNumbers}
              onChange={(e) =>
                setEditedPhones({
                  ...editedPhones,
                  altTelephone: e.target.value,
                })
              }
            />
          </div>

          <div className="phone-field">
            <label>Mobile:</label>
            <input
              type="text"
              value={editedPhones.mobile}
              disabled={!canChangePhoneNumbers}
              onChange={(e) =>
                setEditedPhones({
                  ...editedPhones,
                  mobile: e.target.value,
                })
              }
            />
          </div>

          <div className="label-value-row">
            <label>Emergency Contact Details:</label>
            <span className="value">{selectedPax.ContactDetails}</span>
          </div>

          <div className="label-value-row">
            <label>List Of Your Aids:</label>
            <span className="value">
              {!aidsList.length ? (
                "None"
              ) : (
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "6px",
                  }}
                >
                  {aidsList.map((item, i) => (
                    <span
                      key={i}
                      style={{
                        background: "#eee",
                        padding: "2px 8px",
                        borderRadius: "12px",
                        fontSize: "12px",
                      }}
                    >
                      {item}
                    </span>
                  ))}
                </div>
              )}
            </span>
          </div>

          {clientData?.PaxProfileChangeText && (
            <div
              dangerouslySetInnerHTML={{
                __html: clientData.PaxProfileChangeText,
              }}
            />
          )}
          {canChangePhoneNumbers && (
            <div style={{ marginTop: "15px" }}>
              <button
                onClick={savePaxChanges}
                disabled={!hasChanges || isSaving}
                style={{
                  padding: "10px 20px",
                  backgroundColor: !hasChanges || isSaving ? "#ccc" : "#28a745",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: !hasChanges || isSaving ? "not-allowed" : "pointer",
                  fontSize: "14px",
                  width: "100%",
                }}
              >
                {isSaving ? "Saving..." : "Save Changes"}
              </button>
            </div>
          )}
          {canShowBalance && paxBalance !== null && (
            <p>
              <strong>Account Balance:</strong>{" "}
              <span
                style={{
                  color:
                    paxBalance > 0 ? "green" : paxBalance < 0 ? "red" : "black",
                }}
              >
                {paxBalance !== null
                  ? `£${Number(paxBalance).toFixed(2)}`
                  : "Loading..."}
              </span>{" "}
              <em>(As of today!)</em>
            </p>
          )}

          {allowTopUp && canShowStripe && (
            <div
              style={{
                width: "100%",
                maxWidth: "300px",
                margin: "10px auto",
              }}
            >
              <button
                onClick={onAddFunds}
                style={{
                  width: "100%",
                  padding: "12px 0",
                  backgroundColor: "#6772E5",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  fontSize: "16px",
                }}
              >
                Add Funds with Stripe
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
